/** @format */

export const CLEAR_ERROR = 'CLEAR_ERROR';

export default {
  OVERLAY: {
    SERVER_ERROR: 'OVERLAY_SERVER_ERROR',
  },
};
